module.exports = __webpack_public_path__ + "static/media/TestTypeZeroActive.ec290bed.svg";